import React, { useEffect, useState } from "react";
import { Alert, DepartmentList, Empty, ImageObject, Loading, Pagination, Table, Toast } from "../../../components";
import { DeleteIcon, EditIcon } from "../../../components/Icons/Icons";
import classNames from "classnames/bind";
import image from "../../../assets/images/Avatar.png";
import styles from "./ObjectManager.module.css";
import Filter from "./Filter";
import { colum } from "./ObjectManagerConfig";
import AddObject from "./AddObject";
import { listObjectFSR } from "../../../services/api/listObjectFSR";
import { checkRoleSupAdmin, getTimeFormArray } from "../../../utils";

const cx = classNames.bind(styles);
const ObjectManager = () => {
  const [departments, setDepartments] = useState([]);
  const [showModalDetail, setShowModalDetail] = useState({
    show: false,
    id: null,
    info: null
  })
  const [loading, setLoading] = useState(true)
  const [showAlert, setShowAlert] = useState(false)
  const [modalLoad, setModalLoad] = useState(false)
  const [filter, setFilter] = useState({
    name: null,
    department: null,
    page: 1,
    totalPage: 1,
    size: 10,
    organizationCode: checkRoleSupAdmin() ? null : sessionStorage.getItem("company_code")
  })
  const [deleteId, setDeleteId] = useState('')
  const [reFresh, setReFresh] = useState(false)

  const handleChangeFilter = (key, value) => {
    setFilter(prev => ({ ...prev, [key]: value, page: 1 }))
  }

  const handleShowModalDetail = (id, info) => {
    setShowModalDetail({
      show: true,
      id: id,
      info: info
    })
  }

  const hanldeCloseModalDetail = () => {
    setShowModalDetail({
      show: false,
      id: null,
      info: null
    })
  }

  const getListObject = async () => {
    setLoading(true)
    try {
      const param = {
        id_department: filter?.department,
        nameStaff: filter?.name,
        page: filter?.page,
        limit: filter?.size,
        organization_code: filter?.organizationCode === "all" ? null : filter?.organizationCode
      }
      const res = await listObjectFSR.get(param);
      if (res && res?.data) {
        const objects = res?.data?.map((item, index) => {
          return {
            id: item?.id,
            stt: index + 1,
            name: item?.staffName || '',
            department: item?.nameDepartment || "",
            time: item?.timeAdd ? getTimeFormArray(item?.timeAdd) : '',
            organization_name: item?.organizationName || "",
            // avatar: <div className={cx('image-avatar')}><img style={{ height: '100%' }} src={item?.image ? `${process.env.REACT_APP_FSR_IP}${item?.image}` : image} /></div>,
            avatar: <ImageObject src={item?.image} />,
            action: <div className={cx('action')}>
              <span onClick={() => handleConfirm(item?.id)}>
                <DeleteIcon />
              </span>
              <span onClick={() => handleShowModalDetail(item?.id, item)}>
                <EditIcon />
              </span>
            </div>
          };
        })
        setDepartments(objects)
        setFilter(pre => ({ ...pre, totalPage: Math.ceil(res?.totalElement / filter?.size) }))
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      // console.log(error);
      Toast.open("Lấy danh sách đối tượng không thành công", "danger")
    }
  }

  useEffect(() => {
    if (filter?.organizationCode) {
      getListObject()
    }
  }, [filter?.name, filter?.department, filter?.page, filter?.organizationCode, reFresh])

  const handleChosePage = (page) => {
    setFilter(prev => ({ ...prev, page: page }))
  }
  const handleNextPage = () => {
    setFilter(prev => ({ ...prev, page: prev.page + 1 }))
  }
  const handlePrevPage = () => {
    setFilter(prev => ({ ...prev, page: prev.page - 1 }))
  }

  const handleDelete = async () => {
    setModalLoad(true)
    try {
      await listObjectFSR.delete(deleteId)
      Toast.open("Xóa đối tượng thành công", "success")
      setModalLoad(false)
      handleCancel()
      setReFresh(!reFresh)
    } catch (error) {
      setModalLoad(false)
      Toast.open("Xóa đối tượng không thành công", 'danger')
      handleCancel()
    }
  }

  const handleConfirm = (id) => {
    setDeleteId(id);
    setShowAlert(true);
  }

  const handleCancel = () => {
    setShowAlert(false)
    setDeleteId(null)
  }

  const handleClickRow = (info) => {
    if (!!info) {
      handleShowModalDetail(info?.id || "", info)
    }
  }
  return (
    <div className={cx("container")}>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Quản lý đối tượng</h1>
      </div>
      {showAlert && <Alert title={"Bạn có muốn xóa đối tượng này không"} onClose={handleCancel} onOk={handleDelete} />}
      <Filter value={filter} onChangeFilter={(key, value) => handleChangeFilter(key, value)} onReFresh={() => setReFresh(!reFresh)} />
      <Table colum={colum} data={departments} onClick={handleClickRow} />
      {loading && <div className={cx('loading')}><Loading /></div>}
      {departments?.length > 0 && <div className={cx('pagination')}>
        <Pagination
          pages={filter.totalPage}
          currentPage={filter.page}
          onClick={handleChosePage}
          onNext={handleNextPage}
          onPrevious={handlePrevPage}
        />
      </div>}
      {showModalDetail?.show && <AddObject onClose={hanldeCloseModalDetail} id={showModalDetail?.id} info={showModalDetail.info}
        onReFresh={() => setReFresh(!reFresh)} />}
      {modalLoad && <div className={cx('modalLoad')}><Loading /></div>}
      {departments?.length === 0 && !loading && <Empty title={"Không có dữ liệu phù hợp"} />}

    </div>
  );
};
export default ObjectManager;